var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegisterArrowWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6875 23C41.6875 22.2061 41.0439 21.5625 40.25 21.5625H5.75002C4.95611 21.5625 4.31252 22.2061 4.31252 23C4.31252 23.7939 4.95611 24.4375 5.75002 24.4375H40.25C41.0439 24.4375 41.6875 23.7939 41.6875 23Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2664 10.4835C17.705 9.92216 16.7948 9.92216 16.2335 10.4835L4.73346 21.9835C4.17208 22.5449 4.17208 23.4551 4.73346 24.0165L16.2335 35.5165C16.7948 36.0778 17.705 36.0778 18.2664 35.5165C18.8278 34.9551 18.8278 34.0449 18.2664 33.4835L7.78286 23L18.2664 12.5165C18.8278 11.9551 18.8278 11.0449 18.2664 10.4835Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterArrowWhite);
export default __webpack_public_path__ + "static/media/register-arrow-white.66a6016033939c2fece7fb231a95244d.svg";
export { ForwardRef as ReactComponent };